import { render, staticRenderFns } from "./companyProductPdfBrowser.vue?vue&type=template&id=1810ed42&scoped=true&"
import script from "./companyProductPdfBrowser.vue?vue&type=script&lang=js&"
export * from "./companyProductPdfBrowser.vue?vue&type=script&lang=js&"
import style0 from "./companyProductPdfBrowser.vue?vue&type=style&index=0&id=1810ed42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1810ed42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1810ed42')) {
      api.createRecord('1810ed42', component.options)
    } else {
      api.reload('1810ed42', component.options)
    }
    module.hot.accept("./companyProductPdfBrowser.vue?vue&type=template&id=1810ed42&scoped=true&", function () {
      api.rerender('1810ed42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/companyProductPdfBrowser.vue"
export default component.exports